<p-confirmDialog styleClass="confirm-dialog"></p-confirmDialog>
<p-toast position="bottom-left"></p-toast>

<div class="modifiers-container" *ngIf="isVisible">
  <form [formGroup]="modifiersFormGroup" role="form" [attr.aria-label]="mode === 'view' && hcpcsCode ? 'HCPCS modifiers for ' + hcpcsCode : 'HCPCS modifiers'">
    <div class="modifiers-header">
      <h2 class="section-label">Modifier(s)</h2>
    </div>

    <div class="modifiers-table-wrapper">
      <p-table [value]="modifiersList.controls" styleClass="modifiers-table" [loading]="isLoading">
        <ng-template pTemplate="header">
          <tr>
            <th>Modifier</th>
            <th [ngClass]="{'text-center': mode === 'view'}">Delegated</th>
            <th [ngClass]="{'text-center': mode === 'view'}">PA Required</th>
            <th [ngClass]="{'text-center': mode === 'view'}">PA Allowed</th>
            <th>Modifier Effective<br>Start Date</th>
            <th>Modifier Effective<br>End Date</th>
            <th class="text-left">Status</th>
            <th *ngIf="mode === 'view'"><span class="sr-only">Actions</span></th>
            <th *ngIf="mode !== 'view'"><span class="sr-only">Actions</span></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-modifier let-i="rowIndex">
          <tr [formGroup]="getModifierGroup(i)" 
              class="modifier-data-row"
              [class.editing-row]="isRowEditable(i)">
            <!-- Modifier -->
            <td class="modifier-cell">
              <p-select
                *ngIf="isRowEditable(i)"
                formControlName="modifierId"
                [options]="availableModifiers"
                optionLabel="label"
                optionValue="value"
                placeholder="Select"
                (onChange)="onModifierSelected(i)"
                [class.p-invalid]="getModifierGroup(i).get('modifier')?.invalid && getModifierGroup(i).get('modifier')?.touched"
                appendTo="body">
              </p-select>
              <span *ngIf="!isRowEditable(i)">
                {{ getModifierGroup(i).get('modifier')?.value }}
              </span>
            </td>
            
            <!-- Delegated -->
            <td [ngClass]="{'text-center': mode === 'view'}">
              <p-select
                *ngIf="isRowEditable(i)"
                formControlName="delegated"
                [options]="yesNoOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Select"
                [class.p-invalid]="getModifierGroup(i).get('delegated')?.invalid && getModifierGroup(i).get('delegated')?.touched"
                appendTo="body">
              </p-select>
              <span *ngIf="!isRowEditable(i) && mode !== 'view'">
                {{ getModifierGroup(i).get('delegated')?.value }}
              </span>
              <!-- View mode: Show checkmark or X -->
              <span *ngIf="!isRowEditable(i) && mode === 'view' && getModifierGroup(i).get('delegated')?.value === 'Yes'" 
                    class="status-badge status-badge-success">
                <i class="pi pi-check"></i>
              </span>
              <span *ngIf="!isRowEditable(i) && mode === 'view' && getModifierGroup(i).get('delegated')?.value === 'No'" 
                    class="status-badge status-badge-error">
                <i class="pi pi-times"></i>
              </span>
            </td>
            
            <!-- PA Required -->
            <td [ngClass]="{'text-center': mode === 'view'}">
              <p-select
                *ngIf="isRowEditable(i)"
                formControlName="paRequired"
                [options]="yesNoOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Select"
                [class.p-invalid]="getModifierGroup(i).get('paRequired')?.invalid && getModifierGroup(i).get('paRequired')?.touched"
                appendTo="body">
              </p-select>
              <span *ngIf="!isRowEditable(i) && mode !== 'view'">
                {{ getModifierGroup(i).get('paRequired')?.value }}
              </span>
              <!-- View mode: Show checkmark or X -->
              <span *ngIf="!isRowEditable(i) && mode === 'view' && getModifierGroup(i).get('paRequired')?.value === 'Yes'" 
                    class="status-badge status-badge-success">
                <i class="pi pi-check"></i>
              </span>
              <span *ngIf="!isRowEditable(i) && mode === 'view' && getModifierGroup(i).get('paRequired')?.value === 'No'" 
                    class="status-badge status-badge-error">
                <i class="pi pi-times"></i>
              </span>
            </td>
            
            <!-- PA Allowed -->
            <td [ngClass]="{'text-center': mode === 'view'}">
              <p-select
                *ngIf="isRowEditable(i)"
                formControlName="paAllowed"
                [options]="yesNoOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Select"
                [class.p-invalid]="getModifierGroup(i).get('paAllowed')?.invalid && getModifierGroup(i).get('paAllowed')?.touched"
                appendTo="body">
              </p-select>
              <span *ngIf="!isRowEditable(i) && mode !== 'view'">
                {{ getModifierGroup(i).get('paAllowed')?.value }}
              </span>
              <!-- View mode: Show checkmark or X -->
              <span *ngIf="!isRowEditable(i) && mode === 'view' && getModifierGroup(i).get('paAllowed')?.value === 'Yes'" 
                    class="status-badge status-badge-success">
                <i class="pi pi-check"></i>
              </span>
              <span *ngIf="!isRowEditable(i) && mode === 'view' && getModifierGroup(i).get('paAllowed')?.value === 'No'" 
                    class="status-badge status-badge-error">
                <i class="pi pi-times"></i>
              </span>
            </td>
            
            <!-- Modifier Effective Start Date -->
            <td class="date-cell">
              <div class="date-field-wrapper" *ngIf="isRowEditable(i)">
                <p-datepicker
                  *ngIf="!isStartDateLocked(i)"
                  formControlName="modifierEffectiveStartDate"
                  dateFormat="mm/dd/yy"
                  [showIcon]="true"
                  placeholder="mm/dd/yyyy"
                  appendTo="body">
                </p-datepicker>
                <span *ngIf="isStartDateLocked(i)" class="date-text-locked">
                  {{ getModifierGroup(i).get('modifierEffectiveStartDate')?.value ? (getModifierGroup(i).get('modifierEffectiveStartDate')?.value | date:'MM/dd/yyyy') : '-' }}
                </span>
                <button
                  *ngIf="isStartDateLocked(i)"
                  type="button"
                  class="lock-icon-btn"
                  (click)="toggleStartDateLock(i)"
                  aria-label="Unlock Modifier Effective Start Date"
                  pTooltip="Click to unlock Modifier Effective Dates if they differ from CMS or Plan Effective Dates"
                  tooltipPosition="bottom">
                  <i class="pi pi-lock"></i>
                </button>
              </div>
              <span *ngIf="!isRowEditable(i)" class="date-text">
                {{ getModifierGroup(i).get('modifierEffectiveStartDate')?.value ? (getModifierGroup(i).get('modifierEffectiveStartDate')?.value | date:'MM/dd/yyyy') : '-' }}
              </span>
            </td>
            
            <!-- Modifier Effective End Date -->
            <td class="date-cell">
              <div class="date-field-wrapper" *ngIf="isRowEditable(i)">
                <p-datepicker
                  *ngIf="!isEndDateLocked(i)"
                  formControlName="modifierEffectiveEndDate"
                  dateFormat="mm/dd/yy"
                  [showIcon]="true"
                  placeholder="mm/dd/yyyy"
                  [minDate]="getModifierGroup(i).get('modifierEffectiveStartDate')?.value"
                  appendTo="body">
                </p-datepicker>
                <span *ngIf="isEndDateLocked(i)" class="date-text-locked">
                  {{ getModifierGroup(i).get('modifierEffectiveEndDate')?.value ? (getModifierGroup(i).get('modifierEffectiveEndDate')?.value | date:'MM/dd/yyyy') : '-' }}
                </span>
                <button
                  *ngIf="isEndDateLocked(i)"
                  type="button"
                  class="lock-icon-btn"
                  (click)="toggleEndDateLock(i)"
                  aria-label="Unlock Modifier Effective End Date"
                  pTooltip="Click to unlock Modifier Effective Dates if they differ from CMS or Plan Effective Dates"
                  tooltipPosition="bottom">
                  <i class="pi pi-lock"></i>
                </button>
              </div>
              <span *ngIf="!isRowEditable(i)" class="date-text">
                {{ getModifierGroup(i).get('modifierEffectiveEndDate')?.value ? (getModifierGroup(i).get('modifierEffectiveEndDate')?.value | date:'MM/dd/yyyy') : '-' }}
              </span>
            </td>
            
            <!-- Status -->
            <td class="text-left">
              <span>{{ getModifierGroup(i).get('status')?.value === null ? '' : (getModifierGroup(i).get('status')?.value ? 'Active' : 'Inactive') }}</span>
            </td>
            
            <!-- Blank Column in View Mode -->
            <td *ngIf="mode === 'view'"></td>
            
            <!-- Actions Column -->
            <td *ngIf="mode !== 'view'" class="actions-cell">
              <ng-container *ngIf="!isRowEditable(i)">
                <button
                  type="button"
                  pButton
                  icon="pi pi-pencil"
                  class="p-button-text p-button-sm"
                  (click)="editModifier(i)"
                  pTooltip="Edit"
                  tooltipPosition="top"
                  aria-label="Edit modifier">
                </button>
                <button
                  type="button"
                  pButton
                  icon="pi pi-trash"
                  class="p-button-text p-button-danger p-button-sm"
                  (click)="deleteModifier(i)"
                  pTooltip="Delete"
                  tooltipPosition="top"
                  aria-label="Delete modifier">
                </button>
              </ng-container>
              
              <ng-container *ngIf="isRowEditable(i)">
                <button
                  type="button"
                  pButton
                  icon="pi pi-check"
                  class="p-button-text p-button-success p-button-sm"
                  (click)="saveModifier(i)"
                  pTooltip="Save"
                  tooltipPosition="top"
                  aria-label="Save modifier">
                </button>
                <button
                  type="button"
                  pButton
                  icon="pi pi-times"
                  class="p-button-text p-button-secondary p-button-sm"
                  (click)="cancelModifier(i)"
                  pTooltip="Cancel"
                  tooltipPosition="top"
                  aria-label="Cancel">
                </button>
              </ng-container>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr *ngIf="mode !== 'view'">
            <td colspan="8">
              <button
                type="button"
                pButton
                label="Add Modifier"
                icon="pi pi-plus"
                class="p-button-text p-button-sm p-button-primary add-modifier-btn"
                (click)="addModifier()">
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr *ngIf="mode === 'view'">
            <td colspan="8" class="text-center py-4">
              Add a modifier to enable HCPCS code selection in authorization process.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </form>
</div>
